// Renders the live Desktop (dock + windows) as a click-through overlay on
// top of whatever page it's placed alongside, without adding to that
// page's scroll height or blocking clicks on the page underneath.
//
// Sits at position:fixed/inset:0 (viewport-sized, not document-flow-sized)
// so it doesn't push real page content down. WindowManagerSurface itself
// is pointer-events:none with its direct children (the dock, each open
// ShellAppWindow) re-enabled via WindowManagerSurface.module.css - so
// empty space is click-through, but the dock buttons and window chrome
// stay fully interactive.
//
// Safe to mount on any route: state lives in DesktopStateProvider above
// the Router (see App.js), so it doesn't matter which pages do or don't
// render this - opening/moving a window on one route and later mounting
// this overlay on a different route picks up right where you left off.
import React from "react";
import CustomComponentTestPage from "./CustomComponentTestPage";
import "./PersistentDesktop.css";

export default function PersistentDesktop() {
  return (
    <div
      className="persistentDesktopOverlay"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <CustomComponentTestPage />
    </div>
  );
}
